import * as types from "../../Types/common";

export const SET_USER_DATA = (payload: any) => ({
  type: types.SET_USER_DATA,
  payload
});

export const SET_IS_LOGGED_IN = (payload: any) => ({
  type: types.SET_IS_LOGGED_IN,
  payload
});

export const SET_JOINT_ADDENDUM_STATE = (payload: any) => ({
  type: types.SET_JOINT_ADDENDUM_STATE,
  payload
});

export const setUserData = (payload: {}) => ({
  type: types.USER_DATA,
  payload
});

export const setGeneralDetails = (payload: any) => ({
  type: types.GENERAL_DETAILS,
  payload
});

export const setCovidAndNriDetails = (payload: any) => ({
  type: types.COVID_AND_NRI,
  payload
});

export const SET_TOAST_ERROR = (payload: any) => ({
  type: types.TOAST_ERROR,
  payload
});

export const setLeadId = (payload: string) => ({
  type: types.SET_LEAD_ID,
  payload
});

export const saveGeneralDetailsAction = (apiData: any, leadId: any) => ({
  type: types.SAVE_GENERAL_DETAILS,
  payload: { apiData, leadId }
});

export const saveCovidAndNriDetailsAction = (apiData: any, leadId: any) => ({
  type: types.SAVE_COVID_AND_NRI,
  payload: { apiData, leadId }
});

export const setStepDetails = (payload: any) => ({
  type: types.STEP_DETAILS,
  payload
});

export const setLeadDetails = (payload: any) => ({
  type: types.SET_LEAD_DETAILS,
  payload
});

export const setPostMEFLoading = (payload: boolean) => ({
  type: types.SET_POST_MEF_LOADING,
  payload
});

export const setOtpVerificationDetails = (payload: any) => ({
  type: types.OTP_VERIFICATION_DETAILS,
  payload
});

export const setVerifyOtpLeadId = (payload: any) => ({
  type: types.VERIFY_OTP_LEAD_ID,
  payload
});

export const setLoanStatus = (payload: any) => ({
  type: types.LOAN_STATUS,
  payload
});

export const setMefUploadModal = (payload: any) => ({
  type: types.MEF_UPLOAD_MODAL,
  payload
});
export const setSignatureModal = (payload: any) => ({
  type: types.SIGNATURE_MODAL,
  payload
});

export const setProposalStatus = (payload: any) => ({
  type: types.PROPOSAL_STATUS,
  payload
});

export const setMasterLoading = (payload: boolean) => ({
  type: types.IS_MASTER_LOADING,
  payload
});

export const setRecalculateStatus = (payload: boolean) => ({
  type: types.IS_RECALCULATE_DONE,
  payload
});

export const setRecalculatePremiumError = (message: string) => ({
  type: types.SET_RECALCULATE_ERROR,
  payload: message
});

export const setIsProportionateLead = (status: boolean) => ({
  type: types.SET_PROPORTIONATE_LEAD,
  payload: status
});

export const setIsProportionateParentLead = (status: boolean) => ({
  type: types.SET_PROPORTIONATE_PARENT_LEAD,
  payload: status
});

export const setProductId = (payload: string) => ({
  type: types.SET_PRODUCT_ID,
  payload
});

export const saveNewLeadDetailsAction = (apiData: any) => ({
  type: types.SAVE_NEW_LEAD_DETAILS,
  payload: { apiData }
});

export const setStaffMember = (payload: string) => ({
  type: types.SET_STAFF_MEMBER,
  payload
});

export const savePartnerData = (payload: Record<string, any>) => ({
  type: types.SAVE_PARTNER_DATA,
  payload
});

export const setAssignmentFlagStatus = (payload: boolean) => ({
  type: types.SET_ASSIGNMENT_STEPPER_FLAG,
  payload
});
